import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./pagamento-despesa-listar/pagamento-despesa-listar.module').then(m => m.PagamentoDespesaListarModule) },
        { path: 'pagar', data: { breadcrumb : 'Pagar' }, loadChildren: () => import('./pagamento-despesa-pagar/pagamento-despesa-pagar.module').then(m => m.PagamentoDespesaPagarModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./pagamento-despesa-detalhar/pagamento-despesa-detalhar.module').then(m => m.PagamentoDespesaDetalharModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./pagamento-despesa-inserir/pagamento-despesa-inserir.module').then(m => m.PagamentoDespesaInserirModule) }
    ])],
    exports: [RouterModule]
})
export class PagamentoDespesaAppRoutingModule { }